export const INTEGRATOR_ID = 'client-hub:integrator'
export const SERIALIZED_STATE_SCRIPT_TYPE = 'x-client-hub/serialized-states'
export const SSR_TIMEOUT = 15000
